/**
 * Angular's router drives "try the next route" and "restart from an absolute
 * redirect" with two private Error subclasses, `NoMatch` (carries
 * `segmentGroup`) and `AbsoluteRedirect` (carries `urlTree`). Both are thrown
 * with an empty message and caught inside the recognizer, so one that reaches
 * Sentry is control flow that leaked, not a failed navigation: a real mismatch
 * is reported as NG04002 with the URL in the message.
 */
export function isRouterInternalSignal(error: unknown): boolean {
  return (
    error instanceof Error &&
    error.message === '' &&
    ('segmentGroup' in error || 'urlTree' in error)
  );
}
